import axiosInstance from './axiosInstance';

const updateKriptoStoreStatus = ({ id, nextState }) => {
  return axiosInstance.patch(`/internal/admin/kriptostores/${id}`, {
    next_state: nextState,
  });
};

export default updateKriptoStoreStatus;
